import { render, staticRenderFns } from "./SimpleDialog.vue?vue&type=template&id=57461dbe&scoped=true&"
import script from "./SimpleDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleDialog.vue?vue&type=style&index=0&id=57461dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57461dbe",
  null
  
)

export default component.exports